import { Link } from 'react-router-dom';
import { usePractices } from '../api/use-practices.js';
import { PracticeStar } from './practice-star.js';
import { practiceWords } from './practice-words.js';

/**
 * The Practices row (board R1): always shown, even at 0 (ruled 27 October),
 * with the star the current streak has reached. Home never waits for it: until
 * it arrives the row says Practices and nothing more.
 */
export function PracticesHomeRow({ athleteClientId, to }: { athleteClientId: string | null; to: string }) {
  const state = usePractices(athleteClientId);
  return (
    <Link className="hour-row" to={to}>
      <span className="hour-row-text">
        <span className="name">Practices</span>
        {state.status === 'ready' ? (
          <span className="detail practice-streak-line">
            Current streak {practiceWords.days(state.summary.current_streak)}
            {state.summary.current_star ? <PracticeStar star={state.summary.current_star} /> : null}
          </span>
        ) : null}
      </span>
      <span className="chevron" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
